import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {clearAllFilter} from "../../store/slice/ProductListingFilterApplied";
import CommonFilterSelection from "./CommonFilterSelection";
import useReduxState from "../../hooks/useReduxState";
import { useProductStore } from 'src/hooks/product';
import FadeInOut from "../../component/FadeInOut"; 

const ActiveFilter = (props) => {
    const filter = useSelector((state) => state.entities.ProductListingFilterApplied)
    const list = useSelector((state) => state.entities.ProductListingAPICall.data)
    const [{ category_filter_applied_status }, { }, { }, { }] = useProductStore();
    const [listingAPICallLoader] = useReduxState(false, 'product_listing_listingAPICallLoader', true);
    const dispatch = useDispatch();
    const LoadFilterApplied = (boxSelectorName) => {
        if (filter[boxSelectorName] !== undefined) {
            return <CommonFilterSelection slug={boxSelectorName} list={list}/>
        }
        return '';
    }
    return (
        <>
            <FadeInOut show={true} duration={300} className="filter-records">
                {list && list['@odata.count'] !== undefined &&
                <>
                    {list &&
                    <span>Showing <b>{list['@odata.count'] !== undefined ? list['@odata.count'] : 0}</b> products</span>
                    }
                </>
                }
                <button className={category_filter_applied_status  ? "bs5 btn btn-secondary ms-auto": "bs5 btn btn-secondary ms-auto d-none"}
                        onClick={() => {
                            props.openFilterBoxSettings()
                        }}
                >Add Filters
                </button>
            </FadeInOut>
            {filter !== undefined &&
            Object.entries(filter).length > 0 &&
            <>
                <div className="applied-filters-wrapper">
                    <div className="applied-filters">
                <span className="applied-filters-inner">
                  <div className="filter-controls">
                    <div><strong>Filters</strong></div>
                    <button className="bs5 btn btn-secondary ms-auto filter-brdcrumb-clear"
                            data-di-id="di-id-3a31eb8d-378bc1a3"
                            onClick={() => {
                                dispatch(clearAllFilter());
                            }}
                    >Clear All</button>
                  </div>
                  <div className="filters-breadcrumb">
                   {Object.entries(filter).map((v, i) => (
                       <React.Fragment key={i}>{LoadFilterApplied(v[0])}</React.Fragment>
                   ))
                   }
                  </div>
                </span>
                    </div>
                </div>
            </>
            }
        </>
    );
}

export default ActiveFilter;